export default {
  sm: `
  Actual amount of
  greenhouse gas
  emissions
  `,
  md: `
  Actual amount of
  greenhouse gas emissions
  `,
  xxl: `
  Actual amount of greenhouse
  gas emissions
  `
};
